export default {
  pink: {
    color: '#3E0F33',
  },
  blue: {
    color: '#001C3D',
  },
  purple: {
    color: '#31003D',
  },
  jade: {
    color: '#003322',
  },
  green: {
    color: '#073800',
  },
  lime: {
    color: '#073800',
  },
  mustard: {
    color: '#372D06',
  },
  yellow: {
    color: '#3D2C00',
  },
  orange: {
    color: '#3D1A00',
  },
  red: {
    color: '#3D0700',
  },
  fawn: {
    color: '#372d06',
  },
  concrete: {
    color: '#141515',
  },
  moss: {
    color: '#003322',
  },
  dust: {
    color: '#3d1a00',
  },
  petals: {
    color: '#FFE5F9', //pink 10
  },
  white: {
    color: '#FFFFFF',
  },
}
